import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'Curriculum and Assessment PLD' },
    { value: 2, label: 'Discretionary (Board approved)' },
    { value: 3, label: 'Additional discretionary (Minister approved)' },
    { value: 4, label: 'Emergency' },
    { value: 5, label: 'Strike' },
    { value: 6, label: 'Regional Anniversary' },
    { value: 7, label: 'Statutory Holiday' },
  ],
});
